/**
 * The line between two rows of an E10 list, in the sheet and in the summary: one colour token
 * (`divider`, the mockup border colour) so both lists look the same.
 */
export const ROW_SEPARATOR_SX = {
  '&:not(:last-of-type)': { borderBottom: 1, borderColor: 'divider' },
} as const;
